import { IOrderDataTypeEnum } from "@jti/magento";

export const checkboxFormValueAdapter = (checked: boolean, dataType: IOrderDataTypeEnum): string => {
  if (dataType === IOrderDataTypeEnum.Int) {
    return checked ? "1" : "0";
  }
  return checked ? "true" : "false";
};
